import { identity, get } from 'lodash';

const log = (...message) => {
  process.env.NODE_ENV === 'development' && console.error(...message);
};

const tryTransformEvent = transformEvent => (action, state, vsi) => {
  try {
    return transformEvent(action, state, vsi);
  } catch (e) {
    log('BI: event transformation failed', e, action, state);
  }
};

const tryLogEvent = event => bi => {
  const promise = bi.log(event);
  promise.catch(e => {
    log('BI: external bi error', e, event);
  });
  return promise;
};

const createBiMiddleware = ({
  bi,
  eventMap,
  extendEvent = event => event,
  shouldInvokeEvent = () => true,
  shouldLogEvent = () => true,
  platformAPIs,
}) => {
  const maybeLog = (action, store) => {
    const transformEvent = eventMap[action.type];

    if (!transformEvent) {
      return identity;
    }

    if (!shouldInvokeEvent()) {
      log('BI: not logged action!', action);
      return identity;
    }

    const state = store.getState();
    const biEvent = tryTransformEvent(transformEvent)(
      action,
      state,
      get(platformAPIs, ['bi', 'viewerSessionId'], ''),
    ); // event => bi event
    if (!biEvent) {
      return identity;
    }

    biEvent._ = new Date().getTime();
    // Extend transformEvent with aditional params biToken, visitor_id, member_id
    const extendedEvent = extendEvent(biEvent, state);

    if (!shouldLogEvent(extendedEvent, state)) {
      // not valid because of technical reasons, e.g. missing BI token
      log('BI: not logged event!', extendedEvent);
      return identity;
    }

    return tryLogEvent(extendedEvent);
  };

  return store => next => action => {
    maybeLog(action, store)(bi);

    return next(action);
  };
};

export default createBiMiddleware;
